
import api from './axios';

const API_Base = '/home';

export interface Metric {
    label: string;
    value: string;
    change: string;
    changeType: 'positive' | 'negative' | 'neutral' | 'neutral-purple';
}

export interface Action {
    business: string;
    amount: string;
    stage: string;
    risk: string;
    notes: string;
}

export interface InsightSummary {
    type: string;
    text: string;
}

export interface Signal {
    type: 'red' | 'yellow' | 'green';
    text: string;
}

export interface InsightAction {
    type: 'request' | 'move' | 'flag';
    text: string;
}

export interface HomeInsights {
    summary: InsightSummary[];
    signals: Signal[];
    actions: InsightAction[];
}

const homeApi = {
    getMetrics: async (): Promise<Metric[]> => {
        const response = await api.get(`${API_Base}/metrics`);
        return response.data;
    },

    getActions: async (): Promise<Action[]> => {
        const response = await api.get(`${API_Base}/actions`);
        return response.data;
    },

    getInsights: async (): Promise<HomeInsights> => {
        const response = await api.get(`${API_Base}/insights`);
        return response.data;
    },

    getBusinesses: async (): Promise<{ slug: string, name: string }[]> => {
        // Reuse getActions to get list of unique businesses for now
        // Ideally we'd have a dedicated /businesses endpoint, but this works given our current backend
        const actions = await homeApi.getActions();
        // Return unique businesses
        const unique = new Map();
        actions.forEach(a => {
            // slugify helper
            const slug = a.business.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
            if (!unique.has(slug)) {
                unique.set(slug, { slug: slug, name: a.business });
            }
        });
        return Array.from(unique.values());
    }
};

export default homeApi;
